import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { SelectButton } from 'primereact/selectbutton';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useRef, useState } from "react";
import API from "../Helper/server/API";
import logoimg from "../public/images/logo.png";
import './login.css';
import img_bracelets from "../public/images/bracelets.png";

function VisitorLogin() {
    const toast = useRef(null);
    const [loading_login, set_loading_login] = useState(false);
    const [braceletNumber, setBraceletNumber] = useState("");
    const [loggedInUser, setLoggedInUser] = useState(false);
    const [action, setAction] = useState('select');
    const [qrActiveTab, setQrActiveTab] = useState(0);
    const [scannerRef, setScannerRef] = useState(null);
    const actions = [
        { label: 'استعلام فقط', value: 'select' },
        { label: 'تسجيل دخول', value: 'check_in' },
        { label: 'تسجيل خروج', value: 'check_out' }
    ];

    const userlogin = async (code) => {
        setLoggedInUser(null)

        set_loading_login(true);

        const targetCode = typeof code === 'string' ? code : braceletNumber;

        if (!targetCode || !targetCode.trim()) {
            set_loading_login(false);
            toast.current?.show({
                style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                life: 5000,
                severity: 'warn', summary: 'تنبيه', detail: "يرجى إدخال رقم السوار"
            });
            setBraceletNumber("");
            return;
        }

        try {
            const response = await API.post('web/API/reservationes/services/bracelet_login.php', {
                bracelet_number: targetCode.trim(),
                action: action
            });
            setBraceletNumber("");
            set_loading_login(false);

            if (response?.success === 1) {
                toast.current?.clear();
                toast.current?.show({
                    style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                    life: 5000,
                    severity: 'success', summary: 'مرحباً بك', detail: response?.msg
                });
                setLoggedInUser(response.data);
            } else {
                toast.current?.clear();
                toast.current?.show({
                    style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                    life: 5000,
                    severity: 'error', summary: 'عذراً', detail: response?.msg || "رقم السوار غير صالح اليوم"
                });
            }
        } catch (error) {
            console.error("API request failed:", error);
            set_loading_login(false);
            toast.current?.clear();
            toast.current?.show({
                style: { fontFamily: "Cairo", fontSize: "1.2rem" },
                life: 5000,
                severity: 'error', summary: 'خطأ', detail: "حدث خطأ في الاتصال بالسيرفر"
            });
        }
    };

    useEffect(() => {
        let html5QrcodeScanner;
        if (qrActiveTab === 1 && !loggedInUser) {
            const timer = setTimeout(() => {
                const readerElem = document.getElementById("visitor-reader");
                if (window.Html5QrcodeScanner && readerElem && !readerElem.innerHTML) {
                    html5QrcodeScanner = new window.Html5QrcodeScanner(
                        "visitor-reader",
                        { fps: 10, qrbox: { width: 250, height: 250 } },
                        false
                    );
                    html5QrcodeScanner.render((decodedText) => {
                        userlogin(decodedText);
                    }, (errorMessage) => {
                        // ignore scan errors
                    });
                    setScannerRef(html5QrcodeScanner);
                } else {
                }
            }, 300);

            return () => {
                clearTimeout(timer);
                if (html5QrcodeScanner) {
                    html5QrcodeScanner.clear().catch(error => {
                        console.error("Failed to clear html5QrcodeScanner on cleanup. ", error);
                    });
                }
                setScannerRef(null);
            };
        }
    }, [qrActiveTab, loggedInUser]);

    return (
        <div className="full_container bgbgb" dir="rtl" style={{ backgroundColor: "rgb(21, 40, 60)", minHeight: "100vh" }}>
            <div className="container" style={{ paddingTop: "50px" }}>
                <div className="center verticle_center full_height ">
                    <div className="login_section" style={{ width: "600px", height: "auto" }}>
                        <center>
                            <div style={{
                                background: `url(${logoimg})`,
                                width: "150px",
                                height: "150px",
                                backgroundPosition: "center",
                                position: "relative",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "150px ",
                            }}></div>
                        </center>
                        <hr></hr>
                        <div className="login_form" style={{ padding: "1rem 1rem 1rem 1rem " }} >
                            <form onSubmit={(e) => e.preventDefault()}>
                                <fieldset>
                                    <div className="field text-center ">
                                        <h3 style={{ fontFamily: 'Cairo', color: '#15283c' }}>تحقق من سوار الزائر</h3>
                                    </div>
                                    <div className="field mb-3 d-flex justify-content-center">
                                        <style>{`
                                            .custom-select-button .p-button.p-highlight {
                                                background-color: rgb(20, 176, 204) !important;
                                                border-color: rgb(20, 176, 204) !important;

                                            }
                                            .custom-select-button .p-button {
                                               border: 1px solid #ced4da !important;
                                            }
                                        `}</style>
                                        <SelectButton className="custom-select-button" value={action} options={actions} onChange={(e) => setAction(e.value || 'select')} />
                                    </div>
                                    <hr></hr>

                                    <div className="field mb-3 d-flex justify-content-center">
                                        <SelectButton
                                            className="custom-select-button"
                                            value={qrActiveTab === 0 ? 'manual' : 'camera'}
                                            options={[
                                                { label: 'إدخال يدوي', value: 'manual' },
                                                { label: 'كاميرا القارئ', value: 'camera' }
                                            ]}
                                            onChange={(e) => {
                                                if (e.value) {
                                                    setQrActiveTab(e.value === 'manual' ? 0 : 1);
                                                }
                                            }}
                                        />
                                    </div>

                                    {qrActiveTab === 0 ? (
                                        <div className="field mt-3">
                                            <input
                                                type="text"
                                                name="braceletNumber"
                                                placeholder="أدخل رقم السوار للتحقق"
                                                value={braceletNumber}
                                                onChange={(e) => setBraceletNumber(e.target.value)}
                                                autoFocus
                                                style={{ width: '70%', height: '40px', padding: '5px 10px', border: '1px solid #ced4da', borderRadius: '4px' }}
                                                disabled={loading_login}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        userlogin();
                                                    }
                                                }}
                                            />
                                            <Button dir="ltr" label=" تحقق" raised loading={loading_login} style={{ fontFamily: "Cairo", backgroundColor: "rgb(20, 176, 204)", width: '30%', height: '40px' }}
                                                onClick={() => userlogin()}
                                            />
                                        </div>
                                    ) : (
                                        <div className="field mt-3">
                                            {loading_login && (
                                                <center>
                                                    <br />
                                                    <ProgressSpinner strokeWidth="3" animationDuration="1s" style={{ width: '50px', height: '50px' }} />
                                                    <h6 className="mt-2" style={{ fontFamily: "Cairo", color: '#15283c' }}>جاري التحقق...</h6>
                                                </center>
                                            )}
                                            <div id="visitor-reader" style={{ width: '100%', display: loggedInUser || loading_login ? 'none' : 'block' }}></div>
                                        </div>
                                    )}
                                </fieldset>
                            </form>

                            {loggedInUser ?
                                <div className="login_section" style={{ padding: '40px', backgroundColor: 'white', borderRadius: '8px', textAlign: 'center' }}>

                                    <div style={{ fontSize: '1.2rem', fontFamily: 'Cairo', lineHeight: '2' }}>

                                        <p style={{ color: 'green', fontWeight: 'bold' }}>سوارك فعّال وصالح لليوم</p>


                                        {/* <p><strong>رقم السوار:</strong> {loggedInUser.bracelet_number}</p> */}
                                        <p><strong>حالة السوار:</strong> {loggedInUser.status === 'check_in' ? 'مسجل دخول' : loggedInUser.status === 'check_out' ? 'مسجل خروج' : 'استعلام'}</p>
                                        {loggedInUser.visitor_name && <p><strong>الاسم:</strong> {loggedInUser.visitor_name}</p>}

                                        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', color: '#15283c' }}>
                                            <p><strong>رقم الحجز : </strong> {loggedInUser.ID_reservation}</p>
                                            <p><strong>عدد الأشخاص : </strong> {loggedInUser.number_people}</p>
                                            <p><strong>الأساور المستخدمة : </strong> {loggedInUser.registered_bracelets}</p>
                                            <p><strong>الأساور المتبقية  :</strong> {loggedInUser.number_people - loggedInUser.registered_bracelets}</p>
                                        </div>

                                        {loggedInUser.reservation_services && loggedInUser.reservation_services.length > 0 && (
                                            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#eef2f5', borderRadius: '8px', color: '#15283c' }}>
                                                <h4 style={{ margin: '0 0 10px 0', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>الخدمات والباقات المتاحة لك بحرية</h4>
                                                <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                                                    {loggedInUser.reservation_services.map((service, index) => (
                                                        <li key={index} style={{ marginBottom: '8px', padding: '8px', backgroundColor: 'white', borderRadius: '4px', border: '1px solid #ddd' }}>
                                                            <strong>{service.service_name_ar}</strong>
                                                            {service.rule_type === 'age' ? ` (من ${service.min_age} إلى ${service.max_age} سنة)` : ''}
                                                            {service.persons > 0 ? ` - لعدد ${service.persons} أشخاص` : ''}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}


                                    </div>
                                    <Button label="خروج" className="p-button-danger mt-4" style={{ fontFamily: "Cairo" }} onClick={() => { setLoggedInUser(null); setBraceletNumber(''); }} />
                                </div>
                                : <></>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {/* {
                loggedInUser != null ?
                    <div className="full_container bgbgb" dir="rtl" style={{ backgroundColor: "rgb(21, 40, 60)", minHeight: "100vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div className="login_section" style={{ width: "600px", padding: '40px', backgroundColor: 'white', borderRadius: '8px', textAlign: 'center' }}>
                            <div className="logo_login" style={{
                                background: `url(${logoimg})`, width: "150px", height: "150px", margin: "0 auto 20px", backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "150px "
                            }}></div>
                            <h2 style={{ fontFamily: 'Cairo', color: '#15283c' }}>أهلاً بك في مجمعنا السياحي!</h2>
                            <hr style={{ margin: '20px 0' }} />
                            <div style={{ fontSize: '1.2rem', fontFamily: 'Cairo', lineHeight: '2' }}>
                                <p><strong>رقم السوار:</strong> {loggedInUser.bracelet_number}</p>
                                <p><strong>رقم الحجز:</strong> {loggedInUser.ID_reservation}</p>
                                <p><strong>حالة السوار:</strong> {loggedInUser.status === 'check_in' ? 'مسجل دخول' : loggedInUser.status === 'check_out' ? 'مسجل خروج' : 'استعلام'}</p>
                                {loggedInUser.visitor_name && <p><strong>الاسم:</strong> {loggedInUser.visitor_name}</p>}

                                <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', color: '#15283c' }}>
                                    <h4 style={{ margin: '0 0 10px 0', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>تفاصيل الأساور</h4>
                                    <p><strong>إجمالي الأساور المسموحة:</strong> {loggedInUser.number_people}</p>
                                    <p><strong>الأساور المستخدمة (الذين دخلوا):</strong> {loggedInUser.registered_bracelets}</p>
                                    <p><strong>الأساور المتبقية الصالحة:</strong> {loggedInUser.number_people - loggedInUser.registered_bracelets}</p>
                                </div>

                                {loggedInUser.reservation_services && loggedInUser.reservation_services.length > 0 && (
                                    <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#eef2f5', borderRadius: '8px', color: '#15283c' }}>
                                        <h4 style={{ margin: '0 0 10px 0', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>الخدمات والباقات المتاحة لك بحرية</h4>
                                        <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                                            {loggedInUser.reservation_services.map((service, index) => (
                                                <li key={index} style={{ marginBottom: '8px', padding: '8px', backgroundColor: 'white', borderRadius: '4px', border: '1px solid #ddd' }}>
                                                    <strong>{service.service_name_ar}</strong>
                                                    {service.rule_type === 'age' ? ` (من ${service.min_age} إلى ${service.max_age} سنة)` : ''}
                                                    {service.persons > 0 ? ` - لعدد ${service.persons} أشخاص` : ''}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                <br />
                                <p style={{ color: 'green', fontWeight: 'bold' }}>سوارك فعّال وصالح لليوم. نتمنى لك قضاء وقت ممتع!</p>
                            </div>
                            <Button label="خروج" className="p-button-danger mt-4" style={{ fontFamily: "Cairo" }} onClick={() => { setLoggedInUser(null); setBraceletNumber(''); }} />
                        </div>
                    </div> : <></>
            } */}
        </div>
    );
}
export default VisitorLogin;
